import {Autocomplete, InputLabel, TextField} from "@vapor/react-material";
import React, {useState, useEffect, useCallback, useMemo} from "react";
import DocumentDatePicker from "../../../common-components/DocumentDatePicker";
import SelectCheckboxesArray from "../SelectCheckboxesArray";
import { useTranslation } from "@onefront/react-sdk";
import {documentPeriodType, FilterOptions} from "../../../newDocuments/types";
import {documentPeriodOptions, monthMapping, trimestersOptions} from "../../../newDocuments/DocumentsCostants";
import {createDateIntervals, getStartEndYear} from "../../../newDocuments/document-utils/pureFunctions";


const FilterDocumentsByPeriod = ({ handleFilterChange, selectedFilterYear }) => {
  const yearRange = useMemo(() => {
    return getStartEndYear(selectedFilterYear);
  }, [selectedFilterYear])

  useEffect(() => {
    const yearRange = getStartEndYear(selectedFilterYear);
    setStartDate(yearRange.startDate)
    setEndDate(yearRange.endDate)
  }, [selectedFilterYear]);

  const [startDate, setStartDate] = useState<string >(yearRange.startDate);
  const [endDate, setEndDate] = useState<string>(yearRange.endDate);
  const [documentPeriodSelect, setDocumentPeriodSelect] = useState<documentPeriodType>("Personalizzato");
  const [selectedMonths, setSelectedMonths] = useState<number[]>([]);
  const [selectedTrimesters, setSelectedTrimesters] = useState<number[]>([]);
  const { t } = useTranslation("DOCS");


  useEffect(() => {
    const filterOptions: FilterOptions = {
      startDate: startDate,
      endDate: endDate,
      specificYear: selectedFilterYear,
      filterType: documentPeriodSelect,
      selectedMonths: selectedMonths,
      selectedTrimesters: selectedTrimesters,
    };

    const intervals = createDateIntervals(filterOptions);
    // console.log(intervals, filterOptions, documentPeriod);
    handleFilterChange("dateFilters", intervals);
  }, [
    selectedFilterYear,
    startDate,
    endDate,
    documentPeriodSelect,
    selectedMonths,
    selectedTrimesters,
  ]);

const handleMonthChange = useCallback((selections) => {
  const monthSelections = selections.map((label) => monthMapping[label]);
  setSelectedMonths(monthSelections);
}, []);

const handleTrimesterChange = useCallback((selections) => {
  const trimesterSelections = selections.map((label) => trimestersOptions.indexOf(label));
  setSelectedTrimesters(trimesterSelections);
}, []);


  return (
    <>
      <div style={{ }}>
        <InputLabel>Periodo</InputLabel>
        <Autocomplete
          style={{ width: "auto" }}
          disablePortal
          value={documentPeriodSelect ?? ""}
          onChange={(e, value: documentPeriodType) => setDocumentPeriodSelect(value)}
          options={documentPeriodOptions}
          renderInput={(params) => (
            <TextField
                sx={{
                  "& .MuiAutocomplete-inputRoot .MuiAutocomplete-input": {
                    width: "auto",
                  },
                }}
                placeholder={t("folder.chooseOption")}
              value={documentPeriodSelect ?? ""}
              {...params}
            />
          )}
        />
      </div>
      {documentPeriodSelect === "Personalizzato" && (
        <DocumentDatePicker
          width={"auto"}
          label1={t("document.MonthFilter.startDate")}
          label2={t("document.MonthFilter.endDate")}
          startDate={startDate}
          endDate={endDate}
          setStartDate={setStartDate}
          setEndDate={setEndDate}
        />
      )}
          {documentPeriodSelect === "Mese" && (
            <SelectCheckboxesArray
                label={"Mese"}
              handleCheckboxChange={handleMonthChange}
              documentType={documentPeriodSelect}
              options={Object.keys(monthMapping)}
            />
          )}
          {documentPeriodSelect === "Trimestre" && (
            <SelectCheckboxesArray
                label={"Trimestre"}
              handleCheckboxChange={handleTrimesterChange}
              documentType={documentPeriodSelect}
              options={trimestersOptions}
            />
          )}
    </>
  );
};

export default FilterDocumentsByPeriod;
